import './Navbar.css';
import { useState, useRef, useEffect } from 'react';
import arrow from '../assets/images/arrow.svg';
import arrowMed from '../assets/images/arrowmed.svg';
import arrowLong from '../assets/images/arrowlong.svg';
import arrowtail from '../assets/images/arrowtail.svg';
import hobbitdoor from '../assets/images/hobbitdoor.svg';
import { Link } from 'react-router-dom';
import { URL, } from './constants'


function Navbar() {
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const menuRef = useRef(null); // <- Reference to the menu container

  const handleLogout = async () => {
    try {
      await fetch(`${URL}/logout`, {
        method: "POST",
        credentials: "include", // IMPORTANT for cookies/session
      });

      // optional: redirect after logout
      window.location.href = "/";
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  // Get current date in New Zealand
  const now = new Date();

  // Convert to NZ time
  const nzTime = new Intl.DateTimeFormat("en-NZ", {
    timeZone: "Pacific/Auckland",
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).formatToParts(now);
  // Rebuild as Date object in NZ time
  const nzYear = parseInt(nzTime.find(p => p.type === "year").value);
  const nzMonth = parseInt(nzTime.find(p => p.type === "month").value) - 1; // JS months 0-11
  const nzDay = parseInt(nzTime.find(p => p.type === "day").value);

  const todayNZ = new Date(nzYear, nzMonth, nzDay);
  let target = new Date(nzYear, 8, 21); // 8 = September
  let diffDays = 0
  if (todayNZ < target) {
    const diffMs = target - todayNZ;
    diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  } 

  const tipImage = open
    ? arrowLong
    : hover
    ? arrowMed
    : arrow;

  // Close dropdown on click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef]);

  return (
    <nav className="navbar">
      <img src={hobbitdoor} alt="hobbitdoor" className="hobbitdoor" />
      <div className="navbar-right">
        <h1 className="navbar-title">A Hobbit Birthday Journey</h1>

        {/* Arrow Menu */}
        <div
          className="menu-container"
          ref={menuRef} // <- attach ref here
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <div
            className="arrow-wrapper"
            onClick={() => setOpen(!open)}
          >
            <img src={arrowtail} alt="arrow tail" className="arrow-tail" />
            <span className="arrow-text">menu</span>
            <img src={tipImage} alt="arrow head" className="arrow-head" />
          </div>

          {open && (
            <div className="dropdown">
              <Link to="/hobbithole" className="dropdown-item">home</Link>
              <Link to="/itinerary" className="dropdown-item">group itinerary</Link>
              <Link to="/fellowship" className="dropdown-item">fellowship tracker</Link>
              <Link to="/steps" className="dropdown-item">your journey</Link>
              <div
                className="dropdown-item"
                onClick={() => {
                  setOpen(false);
                  handleLogout();
                }}
              >
                logout
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="countdown">
        <div class="countdown-text">{diffDays} days<br />until 9/21 NZ</div>
      </div>
    </nav>
  );
}

export default Navbar;
